<section
    class="flex flex-col justify-between md:pr-6 ~gap-0/6"
    data-aos="fade-up"
    data-aos-duration="500"
    id="kontakt"
>
    <p
        class="mb-0 md:mb-16 lg:mb-8 px-8 md:px-0 font-medium text-right ~text-3xl/5xl"
    >
        {{ "contactApartment.stillQuestions" | translate }}
    </p>
    <div class="relative flex flex-wrap-reverse items-center">
        @defer {
            <div
                class="flex flex-col justify-between h-full overflow-x-hidden ~gap-8/16"
            >
                <div
                    class="flex items-center gap-4 w-full h-52 animate-move-right"
                    gallerize="gallery-1"
                    selector=".gallery-img-1"
                >
                    @for (image of getFirstHalfImages(); track $index) {
                        <img
                            class="size-40 object-cover gallery-img-1"
                            src="{{ image.data.src }}"
                            [attr.imageSrc]="image.data.src"
                            [attr.thumbSrc]="image.data.thumb"
                            loading="lazy"
                            alt="Kontakt bild galerie"
                        />
                    }
                </div>
                <div
                    class="flex items-center gap-4 w-full h-52 animate-move-left"
                    gallerize="gallery-2"
                    selector=".gallery-img-2"
                >
                    @for (image of getSecondHalfImages(); track $index) {
                        <img
                            class="size-40 object-cover gallery-img-2"
                            src="{{ image.data.src }}"
                            [attr.imageSrc]="image.data.src"
                            [attr.thumbSrc]="image.data.thumb"
                            loading="lazy"
                            alt="Kontakt bild galerie"
                        />
                    }
                </div>
            </div>
        }
        <div
            class="right-0 md:absolute relative bg-white m-8 md:m-0 p-8 border border-neutral-950 rounded-lg w-full md:w-3/5 lg:w-[45%]"
        >
            <p class="font-semibold text-3xl">
                {{ "contactApartment.contactApartment" | translate }}
            </p>
            <p class="mb-8">{{ data().contactInfoText }}</p>
            <app-contact-form [data]="data()"></app-contact-form>
        </div>
    </div>
</section>
